import { Component, inject, input, output } from '@angular/core';
import { Router } from '@angular/router';
import { USER } from '@context/frontend/common';
import { TablePlaceholderComponent } from '@context/frontend/table';
import { RoleAccessPipe } from '@context/frontend/user';
import { AlgoliaGlobal } from '@context/shared/types/search';
import { TranslocoModule } from '@jsverse/transloco';
import { TuiLoader } from '@taiga-ui/core';
import { GlobalSearchChemicalComponent } from '../../global-search-chemical/global-search-chemical.component';
import { GlobalSearchFileComponent } from '../../global-search-file/global-search-file.component';
import { GlobalSearchFolderComponent } from '../../global-search-folder/global-search-folder.component';
import { GlobalSearchMediaComponent } from '../../global-search-media/global-search-media.component';
import { GlobalSearchUserComponent } from '../../global-search-user/global-search-user.component';

@Component({
	imports: [
		TuiLoader,
		TranslocoModule,
		GlobalSearchUserComponent,
		GlobalSearchMediaComponent,
		GlobalSearchFolderComponent,
		GlobalSearchFileComponent,
		GlobalSearchChemicalComponent,
		TablePlaceholderComponent,
		RoleAccessPipe,
	],
	selector: 'ctx-global-search-dropdown',
	templateUrl: 'global-search-dropdown.component.html',
	styleUrl: 'global-search-dropdown.component.scss',
})
export class GlobalSearchDropdownComponent {
	readonly loading = input(false);

	// `metadata` is accessed per discriminated `type` in the template while the
	// child components require concrete Algolia* classes, so the generic stays `any`.
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	readonly data = input<AlgoliaGlobal<any>[]>([]);

	readonly totalElements = input(0);

	readonly selected = output<void>();

	readonly router = inject(Router);
	readonly user = inject(USER);

	onSelect(path: string[]) {
		this.router.navigate(path);
		this.selected.emit();
	}
}
